import { FC } from "react";
import { Divider, Flex, Text, LegacyText, TransparentButton } from "flicket-ui";
import { Icon } from "~components/common";
import { ShoppingCart } from "./shoppingCart";

interface MobileMenuProps {
  title: string;
  type: any;
}

export const MobileMenu: FC<MobileMenuProps> = ({ title, type }) => {
  return (
    <>
      <Flex justifyContent="space-between" alignItems="center" px={2} py={2}>
        <Flex alignItems="center">
          <TransparentButton mr={2} href="/merchandise">
            <Icon icon="chevron-left" fontSize={6} color="N800" />
          </TransparentButton>
          <LegacyText
            lineHeight="normal"
            fontSize={6}
            fontWeight="extraBold"
            color="N800"
            mr={2}
          >
            {title}
          </LegacyText>
        </Flex>
        <ShoppingCart type={type} />
      </Flex>
      <Divider />
    </>
  );
};
